export default __webpack_public_path__ + "static/media/lightning.f45597a5.svg";